/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/auth.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Authorization
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:00 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    LOGIN,
    COMPONENT_UNLOAD,
    ASYNC_START,
    UPDATE_FIELD_AUTH
} from '../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null
            };
        case COMPONENT_UNLOAD:
            return {};
        case ASYNC_START:
            if (action.subtype === LOGIN) {
                return { ...state, inProgress: true };
            }
            break;
        case UPDATE_FIELD_AUTH:
            return { ...state, [action.key]: action.value };
        default:
            return state;
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js